import { useState, useEffect } from "react";
import { BannerConfig } from "@/components/layout/PromotionalBanner";
import { getActiveBanners, shouldShowBanner } from "@/config/banners";

export const useBanner = () => {
  const [activeBanners, setActiveBanners] = useState<BannerConfig[]>([]);
  const [dismissedBanners, setDismissedBanners] = useState<string[]>([]);

  // Initialize with empty dismissed banners on mount (resets on every page load)
  useEffect(() => {
    // No persistence - banners will reappear on refresh
    setDismissedBanners([]);
  }, []);

  // Update active banners when dismissed banners change
  useEffect(() => {
    const allActiveBanners = getActiveBanners();
    const filteredBanners = allActiveBanners.filter((banner) =>
      shouldShowBanner(banner.id, dismissedBanners)
    );
    setActiveBanners(filteredBanners);
  }, [dismissedBanners]);

  const dismissBanner = (bannerId: string) => {
    const newDismissedBanners = [...dismissedBanners, bannerId];
    setDismissedBanners(newDismissedBanners);

    // No persistence - dismissed state only lasts for current page load
    // Banner will reappear on refresh

    // Update active banners list
    setActiveBanners((prev) => prev.filter((banner) => banner.id !== bannerId));
  };

  const clearAllDismissedBanners = () => {
    setDismissedBanners([]);

    // Refresh active banners
    const banners = getActiveBanners();
    setActiveBanners(banners);
  };

  return {
    activeBanners,
    dismissBanner,
    clearAllDismissedBanners,
    dismissedBanners
  };
};
